import AverageTimeChart from './AverageTimeChart.container';

export default AverageTimeChart;
